import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {NewDeletePinComponent} from "../new-delete-pin/new-delete-pin.component";
import {ConvertPinComponent} from "../convert-pin/convert-pin.component";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import { catchError, throwError } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import dayjs from "dayjs";

@Component({
    selector: 'app-marker-pin',
    templateUrl: './marker-pin.component.html',
    styleUrls: ['./marker-pin.component.css'],
    standalone: false
})
export class MarkerPinComponent implements OnInit {
  updatePinForm: FormGroup;
  pins = [];
  currentPin = null;
  dateStringFormatting = 'YYYY-MM-DD' + '  ' + 'hh:mm:ss'; 
  placeholder: string = "-";

  protected readonly dayjs = dayjs;

  pinObj = {
    pinTypeId: this.data.pinTypeId,
    date: this.data.date,
    lat: this.data.lat,
    lng: this.data.lng,
    farm: this.data.farm,
    field: this.data.field,
    fieldId: this.data.fieldId,
    creatingUser: this.data.creatingUser,
    pinId: this.data.pinId,
    pinDescription: this.data.pinDescription,
  }


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public deletePinDialog: MatDialog,
      public convertPinDialog: MatDialog,
      public closePinDialog: MatDialogRef<MarkerPinComponent>,
      public nav: NavBarComponent,
      private pinManagerService: PinManagerService,
  ) {
    this.closePinDialog.backdropClick().subscribe(() => {
      this.close();
    });
    
    this.updatePinForm = new FormGroup({
      pinDescription: new FormControl(null, [Validators.required])
    })

  }

  ngOnInit(): void {

    if(this.data){
        this.updatePinForm.controls.pinDescription.setValue(this.pinObj.pinDescription);
    }
    this.nav.toggleLoading(false);
  }

  close(): void {
    this.closePinDialog.close(this.pinObj);
  }

  updatePin(){
    this.updatePinForm.markAllAsTouched();

    if(this.updatePinForm.valid) {
      this.nav.toggleLoading(true);

      let updatedDescription = this.updatePinForm.controls.pinDescription.value;
      this.pinManagerService.updatePinById(this.pinObj.pinId, updatedDescription).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe(()=>{
        this.closePinDialog.close(this.pinObj);
        this.nav.toggleLoading(false);
      });
    }
  }


  openDeletePinDialog() {
   
    const dialogRef = this.deletePinDialog.open(NewDeletePinComponent, {
      data: {
        pinId: this.pinObj.pinId,
        isBulkDelete: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.option == 'delete'){
        this.closePinDialog.close();
       }
    });
  }

  openConvertPinDialog() {

    const dialogRef = this.convertPinDialog.open(ConvertPinComponent, {
      data: {
        pinId: this.pinObj.pinId,
        pinObj: this.pinObj
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.option == 'convert'){
        this.closePinDialog.close();
       }
    });
  }
}
